export const histogram = {
}



// WEBPACK FOOTER //
// ./src/types/histogram.js